import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { PortalTeamManagerService } from '../portal-team-manager.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EntityCredential } from 'src/app/shared/models/credential/entityCredential';
import { EntityCredentialApplication } from 'src/app/shared/models/credential/entityCredentialApplication';
import { CredentialStatusLabelColor } from 'src/app/shared/models/credential/customPersonCredentialStatusDefinition.model';

@Component({
  selector: 'app-portal-team-credentials',
  templateUrl: './portal-team-credentials.component.html',
  styleUrl: './portal-team-credentials.component.scss',
  standalone: false
})
export class PortalTeamCredentialsComponent implements OnInit, OnDestroy {
  private readonly portalTeamManagerService = inject(PortalTeamManagerService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private paramSub: Subscription;
  public credentials: EntityCredential[] = [];
  public applications: EntityCredentialApplication[] = [];
  public activeCredentialCount: number = 0;
  public CredentialStatusLabelColor = CredentialStatusLabelColor;
  public loading: boolean = true;

  ngOnInit(): void {
    this.paramSub = this.route.paramMap.subscribe(async (params) => {
      this.loading = true;
      const teamId = params.get('id');
      if (!teamId) {
        this.router.navigate(['portal/not-found'], { skipLocationChange: true });
        return;
      }
      const res = await this.portalTeamManagerService.getMyTeamCredentials(teamId);
      this.credentials = res.credentials;
      this.applications = res.applications;
      this.activeCredentialCount = this.credentials.filter((c) => c.isActiveStatus).length;
      this.loading = false;
    });
  }

  ngOnDestroy(): void {
    this.paramSub?.unsubscribe();
  }
}
